const saveStatuses = {
  saveReady: 'Save Layout',
  saveError: 'Save failed',
  saveSuccess: 'Saved!',
  savingStill: 'Still saving...',
  saving: 'Saving...',
};

export default saveStatuses;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/config/saveStatuses.js